import styled from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css'

const defaults = {
  fontSize: '16px',
  iconWidth: '56px',
  iconSpace: '24px',
}

const VideoLink = styled.a`
  display: flex;
  align-items: center;
  font-size: var(--vlink-font-size, ${defaults.fontSize});
  line-height: 1.2;
  transition: color 0.3s ease-out;

  ${noTouch()`
    &:hover {
      color: var(--color-decor);
    }
  `}
`

VideoLink.Icon = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--vlink-icon-width, ${defaults.iconWidth});
  height: auto;
  margin-right: var(--vlink-icon-space, ${defaults.iconSpace});
  color: var(--color-decor);
  background: var(--vlink-icon-bg, var(--color-bg-accent));
  border: 1px solid var(--color-border);
  border-radius: 50%;
  transition: transform 0.3s ease-out;

  &::after {
    content: '';
    display: block;
    width: 100%;
    padding-top: 100%;
  }

  &::before {
    content: '';
    position: absolute;
    width: 0px;
    height: 0px;
    margin-left: 2px;
    border-left: calc(var(--vlink-icon-width, ${defaults.iconWidth}) * 0.281) solid currentColor;
    border-top: calc(var(--vlink-icon-width, ${defaults.iconWidth}) * 0.156) solid transparent;
    border-bottom: calc(var(--vlink-icon-width, ${defaults.iconWidth}) * 0.156) solid transparent;
  }

  ${noTouch()`
    ${VideoLink}:hover & {
      transform: scale(1.1);
    }
  `}
`

export default VideoLink
